var fvChannel = require('glRadio').channel('FV'),
	SidePane = require('./sidePane');
   
module.exports = SidePane.extend({

    // Subpanes: correspond to class of el / data-toggle names (in header)
    // - perhaps store a ref to their el
    // - could print to template
    defaults: _.extend( {}, SidePane.prototype.defaults, {

        subPanes: ['thumbs', 'indexInfo', 'findAndRedact'],
        side: 'left',
        defaultSubPane: 'indexInfo'

    }),

    widthStorageKey: function() {
        return fvChannel.request('localStorage').LEFT_PANE_WIDTH;
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/panelCommon/models/leftPane.js
 ** module id = 755
 ** module chunks = 0
 **/